import { cutToast } from 'utility/toast';
import React from 'react';

import { useMutation } from '@apollo/client';
import {
  WorkgroupGroupDelete,
  WorkgroupGroupDeleteVariables,
} from './__generated__/WorkgroupGroupDelete';
import { EntityDeleteInput } from 'common/types/globalTypes';
import { ActionMessageModal } from 'common/components/ActionMessageModal';
import { EntityAction, EntityType } from 'common/types/utility';
import WORKGROUP_GROUP_DELETE from './WorkgroupGroupDelete.graphql';
import { WorkgroupGroupRow } from '..';

interface DeleteWorkgroupGroupProps {
  selectedRows: WorkgroupGroupRow[];
}

export const DeleteWorkgroupGroup: React.FC<DeleteWorkgroupGroupProps> = ({
  selectedRows,
}) => {
  const [workgroupGroupDelete] = useMutation<
    WorkgroupGroupDelete,
    WorkgroupGroupDeleteVariables
  >(WORKGROUP_GROUP_DELETE, { errorPolicy: 'all' });

  const _onConfirm = async () => {
    const deletableRows: WorkgroupGroupRow[] = selectedRows.filter(
      (item) => item._isDeletable
    );
    const entityDelete: EntityDeleteInput[] = deletableRows.map((item) => {
      return { id: item.id, rowTimestamp: item._rowTimestamp! };
    });
    const { errors } = await workgroupGroupDelete({
      variables: {
        input: {
          entityDelete,
        },
      },
      update(cache) {
        deletableRows.forEach((item) => {
          const identity = cache.identify({
            ...item,
          });
          cache.evict({ id: identity });
          cache.gc();
        });
      },
    });
    if (errors?.length) cutToast.error(errors[0].message);
    else {
      cutToast.success('Record deleted successfully.');
    }
  };

  return (
    <ActionMessageModal
      entityType={EntityType.WorkgroupGroup}
      action={EntityAction.Remove}
      disabled={!selectedRows.some((selected) => selected._isDeletable)}
      visible={!!selectedRows.length}
      multiple={{
        validCount: selectedRows.filter((selected) => selected._isDeletable)
          .length,
        invalidNames: selectedRows
          .filter((selected) => !selected._isDeletable)
          .map((selected) => selected.name || ''),
      }}
      onConfirm={_onConfirm}
    />
  );
};
